export default "__VITE_ASSET__Biddc3B0__"